import { makeStyles, TableRow, TableCell, Checkbox } from '@bb-ui/react-library';
import { LearnInstanceItem } from './MassQueryTooling.types';
import * as React from 'react';
import { ClientData } from 'App.types';

export interface MassQueryToolingRowProps {
  site: LearnInstanceItem;
  clientsMap?: Map<string, ClientData>;
  index: number;
  selected: boolean;
  onToggle: () => void;
}

const useStyles = makeStyles(() => ({
  cellText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

export const MassQueryToolingRow: React.FunctionComponent<MassQueryToolingRowProps> = ({
  site,
  clientsMap,
  index,
  selected,
  onToggle,
}) => {
  const clientName =
    site.ClientId && clientsMap ? (clientsMap.get(site.ClientId)?.name ?? '-') : '-';

  const classes = useStyles();
  const checkboxLabel = `Select ${site.Url || site.InstallationId || site.TenantId || 'site'}`;

  return (
    <TableRow aria-rowindex={index + 1} data-testid={`site-list-table-row-${index}`}>
      <TableCell aria-colindex={1} tabIndex={-1} className={classes.cellText}>
        <Checkbox aria-label={checkboxLabel} checked={selected} onChange={onToggle} />
      </TableCell>

      <TableCell aria-colindex={2} tabIndex={-1} className={classes.cellText}>
        <span>{site.Url || site.Name}</span>
      </TableCell>

      <TableCell aria-colindex={3} tabIndex={-1} className={classes.cellText}>
        <span>{site.InstallationId}</span>
      </TableCell>

      <TableCell aria-colindex={4} tabIndex={-1} className={classes.cellText}>
        <span>{clientName}</span>
      </TableCell>

      <TableCell aria-colindex={5} tabIndex={-1} className={classes.cellText}>
        <span>{site.FleetId}</span>
      </TableCell>

      <TableCell aria-colindex={6} tabIndex={-1} className={classes.cellText}>
        <span>{site.LearnVersion}</span>
      </TableCell>

      <TableCell aria-colindex={7} tabIndex={-1} className={classes.cellText}>
        <span>{new Date(site.created * 1000).toLocaleString()}</span>
      </TableCell>
    </TableRow>
  );
};
